<template>
  <div class="terms-content">
    <p class="terms-title">
      <strong>
        Syarat dan Ketentuan <br />
        Pembukaan Rekening Tabungan dan Deposito
      </strong>
    </p>

    <ul>
      <li>
        Untuk pengajuan deposito dan pembukaan tabungan yang pertama pada setiap Bank Perekonomian Rakyat Syariah (“BPRS”), BPRS akan menghubungi calon nasabah untuk proses validasi data dalam rentang waktu 3 hari kerja (Senin – Jumat).
      </li>
      <li>
        Apabila pembayaran deposito dan/atau setoran pembukaan tabungan diterima setelah jam 13.30 WIB pada hari kerja, maka transaksi akan diproses pada hari kerja berikutnya.
      </li>
      <li>
        BPRS hanya akan menerima uang dalam mata uang rupiah.
      </li>
      <li>
        Bergantung pada ketentuan pada masing-masing BPRS, bagi hasil deposito dapat dicairkan bersamaan dengan nilai pokok deposito pada tanggal jatuh tempo sesuai dengan yang tertera dalam Advis Deposito atau dicairkan pada setiap bulannya selama jangka waktu Deposito (“Tanggal Pencairan Bagi Hasil”).
      </li>
      <li>
        Untuk produk Automatic Roll Over (“ARO”) (hanya untuk produk deposito):
        <ul>
          <li>
            Seluruh bagi hasil deposito akan dicairkan dan ditransfer ke rekening deposan;
          </li>
          <li>
            Nilai pokok deposito kemudian akan diperpanjang sesuai dengan tenor dan persentase bagi hasil yang sama.
          </li>
        </ul>
      </li>
      <li>
        Apabila Tanggal Pencairan Bagi Hasil berada pada hari libur/diluar hari operasional BPRS, maka pencairan akan dilakukan pada hari kerja berikutnya.
      </li>
      <li>
        Penjaminan deposito oleh Lembaga Penjamin Simpanan (“LPS”) mengacu pada tingkat suku bunga penjaminan LPS pada saat ikatan awal pembukaan deposito atau tabungan.
      </li>
      <li>
        Jika pemilik deposito atau tabungan meninggal dunia, deposito atau tabungan atas namanya dapat diserahkan/dialihkan kepada ahli waris.
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TermsContent'
}
</script>

<style scoped>
.terms-content {
  padding: 0 1.5rem;
  box-sizing: border-box;
  width: 100%;
}

.terms-title {
  text-align: center;
  color: #274C8E;
  font-size: 1.5rem;
  margin-bottom: 2rem;
}

.terms-content ul {
  padding-left: 1.5rem;
  margin: 0;
}

.terms-content ul li {
  text-align: justify;
  margin-bottom: 1rem;
  list-style-type: decimal;
}

.terms-content ul ul {
  padding-left: 1.5rem;
  margin-top: 0.5rem;
}

.terms-content ul ul li {
  list-style-type: lower-alpha;
}
</style>


// WEBPACK FOOTER //
// src/components/TermsPengajuanContent.vue